<template>
  <div v-if="showBasketIcon">
    <div class="notifications" style="z-index: 10; overflow: visible;">
      <drop-down
        ref="dropdown"
        :position="'dropdown-menu-left'"
        style="display: block;"
        @toggled="basketToggled"
      >
        <template v-slot:button >
          <a
            id="movebasket-button"
            href="javascript:void(0)"
            :title="$t('movebasket.title_plain')"
          ></a>
        </template>
        <div class="notification-list" @click.stop>
          <div class="container-fluid">
            <div class="row mt-2">
              <div class="col">
                <h3>{{ $t('movebasket.title', { 0: totalQuantity }) }}</h3>
                <hr class="ruler" />
              </div>
            </div>
            <div v-if="isLoaded" class="row">
              <div class="col-12" v-if="count > 0">
                <p class="font-italic">{{ $t('basket.lastadded') }}</p>
              </div>
              <div class="col">
                <div
                  class="row mb-2"
                  v-for="item in movebasketLines"
                  :key="item.AutoID"
                >
                  <div class="col-auto">
                    <a
                      :href="item.ObjectDetailLink"
                      target="_blank"
                      @click.stop
                    >
                      <img
                        class="img-fluid"
                        width="50px"
                        height="50px"
                        :src="item.ImageUrl"
                      />
                    </a>
                  </div>
                  <div class="col">
                    <p class="mb-0">
                      {{ item.Object }} ({{
                        item.IsUniqueItem ? $t('unique') : $t('bulk')
                      }})
                    </p>
                    <p>
                      <span> <b> {{$t('quantity')}}:</b> {{ item.Quantity }} </span>
                    </p>
                  </div>
                  <div class="col-auto">
                    <a
                      v-if="!item.ParentObjectID"
                      href="javascript:void(0)"
                      @click.stop="deleteitem(item)"
                      class="btn btn-sm btn-outline-danger"
                    >
                      X</a
                    >
                    <div v-else class="item-lastcolumn">
                      <span class="badge badge-pill badge-primary"
                        >{{$t('part')}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center py-5" v-if="count === 0">
                {{ $t('movebasket.movebasket_empty') }}
              </div>
            </div>
            <page-loader v-else />
            <div class="row my-2">
              <div class="col align-self-end">
                <loading-button
                  :btn-class="'btn btn-outline-secondary'"
                  class="w-100 mb-2"
                  :title="$t('movebasket.show_basket')"
                  :href="basketDetail"
                />
              </div>
            </div>
          </div>
        </div>
      </drop-down>

      <span class="notification-count badge badge-pill badge-primary mr-1">{{
        totalQuantity
      }}</span>
    </div>
  </div>
</template>

<script>
import DropDown from '@/components/DropDown.vue';
import { geturi } from 'libs/utils.js';
import MoveBasketController from '@/controller/movebasketcontroller';
import PageLoader from '@/components/PageLoader.vue';
import {  Movebasket } from 'libs/classes/security';
const controller = new MoveBasketController();

export default {
  components: {
    'drop-down': DropDown,
    'page-loader': PageLoader
  },
  data() {
    return {
      count: '',
      movebasketLines: [],
      showBasketIcon: false,
      isLoaded: false
    };
  },
  async beforeMount() {
    this.showBasketIcon = await this.$authorize([Movebasket.Movebasket.Read, Movebasket.Movebasket.CreateOrUpdate]);
    await this.updateMoveBasketState();

    window.UpdateMovebasketState2 = this.updateMoveBasketState;
  },
  methods: {
    async updateMoveBasketState() {
      if (!this.showBasketIcon) return;
      try {
        let data = await controller.GetActiveMovebasketInfo();
        if (data) {
          this.MovebasketID = data.MoveBasketID;
          this.count = data.Quantity;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async basketToggled(open) {
      this.updateMoveBasketState();
      if (open && this.MovebasketID > 0) {
        try {
          let result = await controller.GetRecentMoveBasketLines(this.MovebasketID);
          if (result) {
            this.isLoaded = true;
            this.movebasketLines = result.Data;
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        this.isLoaded = true;
      }
    },
    async deleteitem(item) {
      const loader = this.$dialogs.loader();
      try {
        await controller.DeleteMoveBasketItem(this.MovebasketID, item.AutoID);
        
        // Update quantity
        await this.updateMoveBasketState();
        
        // Reload lines because the deleting of parts etc. contains some logic which removes other items
        let result = await controller.GetRecentMoveBasketLines(this.MovebasketID);
        if (result) {
          this.isLoaded = true;
          this.movebasketLines = result.Data;
        }
      } catch (error) {
        this.$toaster.showError(error.Error);
      } finally {
        loader();
      }
    }
  },
  computed: {
    totalQuantity() {
      return this.count;
    },
    basketDetail() {
      return geturi('frontoffice/movebasket');
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';
@import './dropdown.scss';
</style>
